import { Heading, Theme, useStyles } from 'bold-ui'
import { Box } from 'components/Box'
import React, { CSSProperties } from 'react'

type AsideSectionType = 'clickable' | 'flat'

export interface AsideSectionProps {
  title: React.ReactNode
  children: React.ReactNode
  type: AsideSectionType
}

export function AsideSection(props: AsideSectionProps) {
  const { title, children, type } = props
  const { classes } = useStyles(createStyles, type)

  return (
    <Box style={classes.box}>
      <Heading level={3} style={classes.title}>
        {title}
      </Heading>
      {children}
    </Box>
  )
}

AsideSection.defaultProps = { type: 'flat' } as AsideSectionProps

const createStyles = (theme: Theme, type: AsideSectionType) => ({
  box: {
    border: `0.063rem solid ${type === 'flat' ? theme.pallete.gray.c80 : theme.pallete.gray.c60}`,
    borderRadius: `${theme.radius.modal}px`,
    boxSizing: 'border-box',
    boxShadow: type !== 'flat' && theme.shadows.outer[10],
    padding: 0,
    marginBottom: '0.375rem',
    '&:hover': {
      boxShadow: type !== 'flat' && theme.shadows.outer[40],
    },
  } as CSSProperties,
  title: {
    background: theme.pallete.gray.c90,
    padding: '0.5rem 1rem',
    borderRadius: `${theme.radius.modal}px`,
  },
})
